/**
 * PCM Legacy Global Stubs
 *
 * Pure no-op globals kept only so old migrated content (post/page bodies
 * with inline scripts from before the 2026 rebuild) that still calls
 * `preloadContent()`/`loadReviews()` doesn't throw a ReferenceError. Neither
 * function is called anywhere in this theme's own code - if you're looking
 * for real functionality, it isn't here.
 */
(function(window) {
  'use strict';

  function defineGlobal(name, callback) {
    if (typeof window[name] !== 'function') {
      window[name] = callback;
    }
  }

  defineGlobal('preloadContent', function() {
    return false;
  });

  defineGlobal('loadReviews', function() {
    return false;
  });
})(window);
